import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { RequestModel, ReturnModel } from '../models/models'

export class GetFavProductDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/FavProductStats',
      requesterInfo,
    })
  }

  public async getFavProductData(req: RequestModel): Promise<ReturnModel[]> {
    return await this.postAsync<ReturnModel[]>(req)
  }
}
